(function () {
  /* Availability check for each race number choice against the reserved-numbers sheet.
     Sheet layout: column pairs (number, holder). A non-empty holder cell marks the number as reserved.
     Numbers match as written: 7, 07 and 007 are separate entries.
     Source order: the server-rendered list in script[data-mbr-numbers] when it matches this sheet and tab
     and is under 24h old; otherwise the live CSV export by gid (data-mbr-tabs maps type to gid),
     falling back to the older server-rendered list (up to 7 days) if the live fetch fails.
     A taken number counts as the racer's own when the Racer Name field matches its holder:
     directly against the live sheet, or by fingerprint (first 10 hex of SHA-256 of "number|name")
     against the server-rendered list. */
  var root = document.querySelector('[data-mbr-sheet]');
  if (!root) return;
  var match = /\/spreadsheets\/d\/([A-Za-z0-9_-]+)/.exec(root.getAttribute('data-mbr-sheet') || '');
  if (!match) return;
  var sheetId = match[1];
  var byType = root.getAttribute('data-mbr-by-type') === 'true';
  var gids = {};
  (root.getAttribute('data-mbr-tabs') || '').split(',').forEach(function (p) {
    var kv = p.split(':');
    if (kv.length === 2 && /^\d+$/.test(kv[1].trim())) gids[kv[0].trim().toUpperCase()] = kv[1].trim();
  });
  var cache = {};
  var vehicle = '';
  var NUM_FIELD = /(first|1st|second|2nd|third|3rd) choice/i;
  var FIRST_FIELD = /(first|1st) choice/i;
  var NAME_FIELD = /racer name/i;
  var MAX_AGE_MS = 864e5;
  var FALLBACK_AGE_MS = 6048e5;
  var records = [];
  var synced = readSynced();

  /* { updated_at: epoch seconds, lists: { ATV | UTV | _: { v, sheet, gid, open, taken } } } */
  function readSynced() {
    var el = document.querySelector('script[data-mbr-numbers]');
    if (!el) return null;
    try {
      var d = JSON.parse(el.textContent);
      return d && d.lists ? d : null;
    } catch (e) {
      return null;
    }
  }

  function syncedList(tab) {
    if (!synced) return null;
    var p = synced.lists[tab || '_'];
    var gid = tab ? gids[tab] : '0';
    if (!p || p.v !== 1 || p.sheet !== sheetId || String(p.gid) !== gid) return null;
    return p;
  }

  function syncedAge() {
    var t = Number(synced && synced.updated_at) * 1000;
    return t > 0 ? Date.now() - t : Infinity;
  }

  /* open: "n n ..."; taken: "n:fp,fp n ..." */
  function fromSynced(p) {
    var listed = {}, taken = {}, fps = {};
    String(p.open || '').split(' ').forEach(function (k) { if (k) listed[k] = true; });
    String(p.taken || '').split(' ').forEach(function (t) {
      if (!t) return;
      var i = t.indexOf(':');
      var k = i < 0 ? t : t.slice(0, i);
      listed[k] = taken[k] = true;
      if (i >= 0) fps[k] = t.slice(i + 1).split(',');
    });
    return { listed: listed, taken: taken, fps: fps, names: null };
  }

  function parseCsv(text) {
    var rows = [], row = [], cell = '', q = false;
    for (var i = 0; i < text.length; i++) {
      var c = text[i];
      if (q) {
        if (c === '"') {
          if (text[i + 1] === '"') { cell += '"'; i++; } else q = false;
        } else cell += c;
      } else if (c === '"') q = true;
      else if (c === ',') { row.push(cell); cell = ''; }
      else if (c === '\n') { row.push(cell); rows.push(row); row = []; cell = ''; }
      else if (c !== '\r') cell += c;
    }
    if (cell || row.length) { row.push(cell); rows.push(row); }
    return rows;
  }

  /* NFKD, lowercase, a-z only; same rule as the sync script */
  function normName(s) {
    s = String(s || '');
    if (s.normalize) s = s.normalize('NFKD');
    return s.toLowerCase().replace(/[^a-z]/g, '');
  }

  /* Returns { listed, taken, names: {n: [normalized holders]} } keyed by the number as written; letter O read as zero */
  function index(rows) {
    var listed = {}, taken = {}, names = {};
    rows.forEach(function (r) {
      for (var c = 0; c + 1 < r.length; c += 2) {
        var key = r[c].trim();
        if (!/^[\dOo]{1,3}$/.test(key) || !/\d/.test(key)) continue;
        key = key.replace(/[Oo]/g, '0');
        listed[key] = true;
        var holder = r[c + 1].trim();
        if (!holder) continue;
        taken[key] = true;
        (names[key] = names[key] || []).push(normName(holder));
      }
    });
    return { listed: listed, taken: taken, fps: null, names: names };
  }

  function fetchLive(tab) {
    var base = 'https://docs.google.com/spreadsheets/d/' + sheetId;
    var gid = tab ? gids[tab] : '0';
    var url = gid ? base + '/export?format=csv&gid=' + gid :
      base + '/gviz/tq?tqx=out:csv&sheet=' + encodeURIComponent(tab);
    return fetch(url, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { return index(parseCsv(t)); });
  }

  function load(tab) {
    var key = tab || '_';
    if (!cache[key]) {
      var p = syncedList(tab);
      if (p && syncedAge() < MAX_AGE_MS) {
        cache[key] = Promise.resolve(fromSynced(p));
      } else {
        cache[key] = fetchLive(tab).catch(function (e) {
          if (p && syncedAge() < FALLBACK_AGE_MS) return fromSynced(p);
          delete cache[key];
          throw e;
        });
      }
    }
    return cache[key];
  }

  function hex10(buf) {
    var b = new Uint8Array(buf), out = '';
    for (var i = 0; i < 5; i++) out += (b[i] < 16 ? '0' : '') + b[i].toString(16);
    return out;
  }

  /* Resolves true when the Racer Name in the form matches a holder of taken number n */
  function isOwn(ix, n, form) {
    var who = '';
    if (form) {
      Array.prototype.forEach.call(form.querySelectorAll('input, textarea'), function (f) {
        if (!who && NAME_FIELD.test(fieldName(f))) who = normName(f.value);
      });
    }
    if (!who) return Promise.resolve(false);
    if (ix.names) return Promise.resolve((ix.names[n] || []).indexOf(who) >= 0);
    var list = ix.fps && ix.fps[n];
    var subtle = window.crypto && window.crypto.subtle;
    if (!list || !list.length || !subtle || typeof TextEncoder === 'undefined') return Promise.resolve(false);
    return subtle.digest('SHA-256', new TextEncoder().encode(n + '|' + who))
      .then(function (buf) { return list.indexOf(hex10(buf)) >= 0; })
      .catch(function () { return false; });
  }

  function fieldName(el) {
    return (el.getAttribute('name') || '') + ' ' + (el.getAttribute('aria-label') || '') + ' ' + (el.getAttribute('data-name') || '');
  }

  /* One record per number input: its status line, request sequence and debounce timer */
  function recordFor(el) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].el === el) return records[i];
    }
    var rec = { el: el, status: null, seq: 0, timer: 0, first: FIRST_FIELD.test(fieldName(el)) };
    records.push(rec);
    return rec;
  }

  function statusFor(rec) {
    if (!rec.status || !rec.status.isConnected) {
      rec.status = document.createElement('p');
      rec.status.className = 'mbr-numcheck';
      rec.status.setAttribute('aria-live', 'polite');
      rec.el.insertAdjacentElement('afterend', rec.status);
    }
    return rec.status;
  }

  /* quiet: update the line without announcing it (interim "checking" state) */
  function show(rec, kind, text, quiet) {
    var el = statusFor(rec);
    el.setAttribute('aria-live', quiet ? 'off' : 'polite');
    el.className = 'mbr-numcheck' + (kind ? ' is-' + kind : '');
    el.textContent = text;
    if (!rec.first) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-mbr-num]'), function (n) {
      var plate = n.closest('.mbr-card-num') || n;
      plate.classList.toggle('is-open', kind === 'open');
      plate.classList.toggle('is-taken', kind === 'taken');
    });
  }

  function check(rec) {
    var n = String(rec.el.value || '').replace(/\D/g, '').slice(0, 4);
    var mine = ++rec.seq;
    if (!n) return show(rec, '', '');
    if (byType && !vehicle) return show(rec, 'wait', 'Pick ATV or UTV to check #' + n + '.');
    show(rec, 'wait', 'Checking #' + n + '…', true);
    load(byType ? vehicle : '').then(function (ix) {
      if (mine !== rec.seq) return;
      var label = '#' + n + (byType ? ' (' + vehicle + ')' : '');
      if (ix.taken[n]) {
        return isOwn(ix, n, rec.el.closest('form')).then(function (own) {
          if (mine !== rec.seq) return;
          if (own) show(rec, 'open', label + ' is yours from last season.');
          else show(rec, 'taken', label + ' is taken. Try another number.');
        });
      }
      if (ix.listed[n]) show(rec, 'open', label + ' is open.');
      else show(rec, 'wait', label + " isn't on the sheet. Check it before you submit.");
    }).catch(function () {
      if (mine === rec.seq) show(rec, 'wait', "Couldn't reach the numbers sheet. Check it before you submit.");
    });
  }

  function queue(rec) {
    clearTimeout(rec.timer);
    rec.timer = setTimeout(function () { check(rec); }, 350);
  }

  function recheckAll(form) {
    records = records.filter(function (r) { return r.el.isConnected; });
    Array.prototype.forEach.call(form.querySelectorAll('input, select, textarea'), function (f) {
      if (NUM_FIELD.test(fieldName(f)) && String(f.value || '').trim()) queue(recordFor(f));
    });
  }

  function onField(e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var form = el.closest('form[action*="/cart/add"]');
    if (!form) return;
    var name = fieldName(el);
    if (NUM_FIELD.test(name)) {
      queue(recordFor(el));
    } else if (/vehicle type/i.test(name)) {
      if (el.type === 'radio' && !el.checked) return;
      var v = String(el.value || '').trim().toUpperCase();
      vehicle = /^(ATV|UTV)$/.test(v) ? v : '';
      recheckAll(form);
    } else if (NAME_FIELD.test(name)) {
      recheckAll(form);
    }
  }

  /* Create the empty live region before the first message so that message is announced */
  document.addEventListener('focusin', function (e) {
    var el = e.target;
    if (el && el.closest && el.closest('form[action*="/cart/add"]') && NUM_FIELD.test(fieldName(el))) statusFor(recordFor(el));
  }, true);
  document.addEventListener('input', onField, true);
  document.addEventListener('change', onField, true);
})();
